export default "__VITE_ASSET__CKo9u5b$__"